<template>
    <div v-if="!isLoading" class="col-lg-12">
        <template>
            <h4 class="card-header p-2 mb-3 rounded" style="font-size: 1rem">{{ $t('managerForm.settingPage.pageTypeI.titleInvite') }}</h4>
            <div class="form-group row">
                <label class="col-sm-2 text-nowrap"
                    >{{ $t('managerForm.settingPage.pageTypeI.invite.emailSubject') }}
                    <span v-if="onHandleCheckFieldRequired(configField.invite.subject.typesValidate)" class="text-danger">*</span></label
                >
                <div class="col-sm-6">
                    <InputText
                        :model.sync="dataForm.invite.subject"
                        :config.sync="configField.invite.subject"
                        :disabled="isView"
                        @blur="handleValidateField(dataForm.invite.subject, configField.invite.subject)"
                    />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 text-nowrap"
                    >{{ $t('managerForm.settingPage.pageTypeI.invite.templateSelection') }}
                    <span v-if="onHandleCheckFieldRequired(configField.invite.template.typesValidate)" class="text-danger">*</span></label
                >
                <div class="col-sm-6">
                    <Multiselect
                        :id="`select-template-invite`"
                        :value.sync="dataForm.invite.template"
                        :options="optionTemplate"
                        :config.sync="configField.invite.template"
                        :disabled="isView"
                        @open="onHandleOpenTemplate('typeInvite')"
                        @select="onHandleSelectTemp('typeInvite', dataForm.invite.template)"
                        @remove="removeTemplateMail('typeInvite')"
                    />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 text-nowrap"
                    >{{ $t('managerForm.settingPage.pageTypeI.invite.senderEmail') }}
                    <span v-if="onHandleCheckFieldRequired(configField.invite.email_sender.typesValidate)" class="text-danger">*</span></label
                >
                <div class="col-sm-6">
                    <Multiselect
                        :id="`select-send-from-invite`"
                        :value.sync="dataForm.invite.email_sender"
                        :options="optionSenderMail"
                        :config.sync="configField.invite.email_sender"
                        :disabled="isView"
                        @select="onHandleSelectSenderMail"
                    />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 text-nowrap"
                    >{{ $t('managerForm.settingPage.pageTypeI.emailFormat') }}
                    <span v-if="onHandleCheckFieldRequired(configField.invite.type.typesValidate)" class="text-danger">*</span></label
                >
                <div class="col-sm-6">
                    <div class="d-flex">
                        <div v-for="item in optionSendType" :key="item.id">
                            <InputRadio
                                class="mr-4"
                                :model.sync="dataForm.invite.type"
                                :name="`invite-sendType`"
                                :id="`invite-sendType-${item.id}`"
                                :value="item.value"
                                :label="item.label"
                                :disabled="isView"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 text-nowrap"
                    >{{ $t('managerForm.settingPage.pageTypeI.invite.emailBody') }}
                    <span v-if="onHandleCheckFieldRequired(configField.invite.body.typesValidate)" class="text-danger">*</span></label
                >
                <div class="col-sm-6">
                    <TextareaComponent
                        :model.sync="dataForm.invite.body"
                        :rows="`12`"
                        :config.sync="configField.invite.body"
                        :disabled="isView"
                        @blur="handleValidateField(dataForm.invite.body, configField.invite.body)"
                    >
                        <div v-if="configField.invite.body.error" class="d-block invalid-feedback">
                            <span>
                                {{ configField.invite.body.errorCustomMess }}
                            </span>
                        </div>
                    </TextareaComponent>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-2"></div>
                <div class="col-10">
                    <div class="d-flex align-items-start">
                        <div class="col-5 pl-0">
                            <InputText
                                :model.sync="FORM_SEND_MAIL.invite_mail_send_test"
                                :config.sync="configSendMail.invite_mail_send_test"
                                :disabled="isView"
                                @blur="handleValidateField(FORM_SEND_MAIL.invite_mail_send_test, configSendMail.invite_mail_send_test)"
                            />
                        </div>
                        <button
                            :disabled="!FORM_SEND_MAIL.invite_mail_send_test || configSendMail.invite_mail_send_test.error || isView"
                            type="button"
                            class="btn btn-info"
                            @click="onHandleTestMail('typeInvite')"
                        >
                            {{ $t('managerForm.settingPage.buttonType.testSend') }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-2"></div>
                <div class="col-10">
                    <div class="d-flex">
                        <button :disabled="isView" type="button" class="btn btn-success mr-3" @click="onHandleSaveTempMail('typeInvite')">
                            {{ $t('managerForm.saveTemporarily') }}
                        </button>
                        <button :disabled="isView" type="button" class="btn btn-primary" @click="onHandleOpenListTemp('typeInvite')">
                            {{ $t('managerForm.ListTemporarily') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
        <ModalCommon :id="`tempMail`" :config="configModalTempMailI" @save="submitTempMail()" @close="closeTempMail()">
            <div class="form-group row">
                <label class="col-sm-3"
                    >{{ $t('managerForm.temporarily.nameTemp') }}
                    <span v-if="onHandleCheckFieldRequired(configFormTempMailI.name_template.typesValidate)" class="text-danger">*</span></label
                >
                <div class="col-sm-9">
                    <InputText
                        :model.sync="initFormTempMailI.name_template"
                        :config.sync="configFormTempMailI.name_template"
                        :disabled="isView"
                        @blur="handleValidateField(initFormTempMailI.name_template, configFormTempMailI.name_template)"
                    />
                </div>
            </div>
        </ModalCommon>

        <ModalListTemplateMail
            :listTemplateMail="optionTemplate"
            :listSenderMail="optionSenderMail"
            :configModal="configListTemplate"
            @refreshListTemplate="onHandleRefreshListTemplate"
        />
    </div>
    <div class="d-flex justify-content-center" v-else>
        <LoadingIcon />
    </div>
</template>

<script>
import { InputText, InputRadio } from '@/components/Input';
import { validateField, validateAllField } from '@/utils/validate_v2';
import { onHandleCheckFieldRequired } from '@/utils/handlers';
import { managerFormMethods } from '@/state/helpers';
import {
    FORM_SEND_MAIL,
    configSendMail,
    initForm,
    configForm,
    initFormTempMailI,
    configFormTempMailI,
    configModalTempMailI,
    optionSendType,
    TYPE_TEMPLATE,
    configListTemplate
} from './constants-mail';
import { showMessage } from '@/utils/messages';

import Multiselect from '@/components/Multiselect/main.vue';
import TextareaComponent from '@/components/Textarea/main.vue';
import ModalCommon from '@/components/Modal/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import ModalListTemplateMail from './modal-list-template-mail.vue';

export default {
    name: 'PageSettingMailI',
    components: { InputText, InputRadio, Multiselect, TextareaComponent, ModalCommon, LoadingIcon, ModalListTemplateMail },
    props: {
        dataMailTemplate: {
            type: Object,
            required: true
        },
        isView: {
            type: Boolean,
            default: false
        },
        optionTemplate: {
            type: Array,
            required: true
        },
        optionSenderMail: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            dataForm: initForm(),
            configField: configForm(),
            FORM_SEND_MAIL: FORM_SEND_MAIL(),
            configSendMail: configSendMail(),
            initFormTempMailI: initFormTempMailI(),
            configFormTempMailI: configFormTempMailI(),
            configModalTempMailI,
            optionSendType,
            configListTemplate,
            isLoadingSubmitTemp: false,
            isLoading: true,
            routerView: this.$route.name
        };
    },

    methods: {
        ...managerFormMethods,
        onHandleCheckFieldRequired,
        handleValidateField(valueField, configField) {
            validateField(valueField, configField);
        },

        onHandleSubmit() {
            let isCheck = validateAllField(this.dataForm, this.configField);
            if (!isCheck) return isCheck;
            this.$emit('update:dataMailTemplate', {
                ...this.dataForm,
                template_name: this.dataForm?.template?.name ?? ''
            });
            return isCheck;
        },

        onHandleSaveTempMail(typeSave) {
            let isCheck = true;
            let configInviteForm = JSON.parse(JSON.stringify(this.configField.invite));
            configInviteForm.email_sender.typesValidate = [];

            if (typeSave === 'typeInvite') {
                isCheck = validateAllField(this.dataForm.invite, configInviteForm);
                if (!isCheck) return;
                this.configModalTempMailI.template_type = TYPE_TEMPLATE.INVITE;
            }
            this.configModalTempMailI.model = true;
        },
        async submitTempMail() {
            if (this.isLoadingSubmitTemp) return;
            this.isLoadingSubmitTemp = true;
            let isCheck = validateAllField(this.initFormTempMailI, this.configFormTempMailI);
            if (!isCheck) return;
            let payloadTempMail = {
                template_type: this.configModalTempMailI.template_type
            };
            if (this.configModalTempMailI.template_type === TYPE_TEMPLATE.INVITE) {
                payloadTempMail = {
                    ...payloadTempMail,
                    ...this.dataForm.invite,
                    email_sender: {
                        id: this.dataForm?.invite?.email_sender?.id,
                        email_address: this.dataForm?.invite?.email_sender?.email_address
                    }
                };
            }
            payloadTempMail.template_name = this.initFormTempMailI.name_template;
            delete payloadTempMail.template;
            delete payloadTempMail.email_sender;
            try {
                const dataPayload = await this.registerTemplateMail(payloadTempMail);
                if (dataPayload?.code === 200) {
                    showMessage(dataPayload?.code, this.$bvToast, 'メールのテンプレートが作成されました。');
                } else {
                    showMessage(dataPayload?.code, this.$bvToast, dataPayload?.message);
                }
                this.configModalTempMailI.model = false;
                this.initFormTempMailI = initFormTempMailI();
                this.configFormTempMailI = configFormTempMailI();
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoadingSubmitTemp = false;
            }
        },
        closeTempMail() {
            this.initFormTempMailI = initFormTempMailI();
            this.configFormTempMailI = configFormTempMailI();
        },

        async onHandleTestMail(typeTest) {
            let isCheck = true;
            let payloadTestMail = {
                form_id: this.$route.query.id
            };
            if (typeTest === 'typeInvite') {
                isCheck = validateAllField(this.dataForm.invite, this.configField.invite);
                if (!isCheck) return;
                payloadTestMail = {
                    ...this.dataForm.invite,
                    ...payloadTestMail,
                    email: this.FORM_SEND_MAIL.invite_mail_send_test,
                    email_sender: {
                        id: this.dataForm.invite.email_sender.id,
                        email_address: this.dataForm.invite.email_sender.email_address
                    }
                };
            }
            delete payloadTestMail.template;
            delete payloadTestMail.template_name;
            try {
                const dataPayload = await this.sendMailTest(payloadTestMail);
                if (dataPayload?.code === 200) {
                    showMessage(dataPayload?.code, this.$bvToast, 'テスト用のメールが送信されました。');
                } else {
                    showMessage(dataPayload?.code, this.$bvToast, dataPayload?.message);
                }
            } catch (error) {
                console.log('error', error);
            }
        },

        onHandleOpenTemplate(typeOpen) {
            this.$emit('openTemplate', typeOpen);
        },

        onHandleRefreshListTemplate(typeRefresh) {
            this.$emit('openTemplate', typeRefresh === TYPE_TEMPLATE.INVITE ? 'typeInvite' : '');
        },

        onHandleSelectTemp(typeSelect, selectedOption) {
            if (typeSelect === 'typeInvite') {
                this.dataForm.invite = {
                    ...initForm().invite,
                    ...selectedOption,
                    email_sender: this.dataForm.invite.email_sender
                };
                this.configField.invite.email_sender.error = false;
            }
            this.$emit('update:dataMailTemplate', this.dataForm);
        },
        removeTemplateMail(typeRemove) {
            if (typeRemove === 'typeInvite')
                this.dataForm.invite = {
                    ...initForm().invite,
                    email_sender: this.dataForm.invite.email_sender,
                    body: '{{URL}}'
                };
        },
        onHandleSelectSenderMail() {
            this.$emit('update:dataMailTemplate', this.dataForm);
        },

        onHandleOpenListTemp(typeOpenList) {
            this.$emit('openTemplate', typeOpenList);
            this.configListTemplate.typeTemplate = typeOpenList === 'typeInvite' ? TYPE_TEMPLATE.INVITE : '';
            this.configListTemplate.model = true;
        }
    },

    watch: {
        dataMailTemplate: {
            async handler() {
                this.isLoading = false;
                this.dataForm = {
                    ...initForm(),
                    invite: {
                        ...this.dataMailTemplate.invite,
                        type: this.dataMailTemplate?.invite.type || 'text'
                    }
                };
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {}
};
</script>

<style lang="scss" scoped></style>
